export async function addLinesToStorefrontCart(endpoint, storefrontAccessToken, cartId, lines) {
	const query = `
	  mutation addLinesToCart($cartId: ID!, $lines: [CartLineInput!]!) {
		cartLinesAdd(cartId: $cartId, lines: $lines) {
		  cart {
			id
			lines(first: 10) {
			  edges {
				node {
				  id
				  quantity
				  merchandise {
					... on ProductVariant {
					  title
					}
				  }
				}
			  }
			}
			cost {
			  totalAmount {
				amount
			  }
			}
		  }
		  userErrors {
			field
			message
		  }
		}
	  }
	`;

	const variables = {
	  cartId: cartId,
	  lines: lines
	};

	try {
	  const response = await fetch(endpoint, {
		method: "POST",
		headers: {
		  "Content-Type": "application/json",
		  "X-Shopify-Storefront-Access-Token": storefrontAccessToken
		},
		body: JSON.stringify({ query, variables })
	  });

	  return await response.json();
	} catch (err) {
	  console.error("❌ Failed to add lines to Storefront cart:", err);
	  throw err;
	}
  }